import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import BlogArticle from "../pages/blog/article/page";
import BlogBudgetSpreadsheet from "../pages/blog/budget-spreadsheet/page";
import BlogSneakersVsBoots from "../pages/blog/sneakers-vs-boots/page";
import BlogCompareOnline from "../pages/blog/compare-online/page";
import BlogTop100 from "../pages/blog/top-100-list/page";
import BlogFashionDatabase from "../pages/blog/fashion-database/page";
import BlogVsTraditional from "../pages/blog/vs-traditional/page";
import BlogValueSneakers from "../pages/blog/value-sneakers-2026/page";
import BlogResearchSystem from "../pages/blog/research-system/page";
import BlogBuySmarter from "../pages/blog/buy-smarter/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/blog/pandabuy-sheet-ultimate-guide",
    element: <BlogArticle />,
  },
  {
    path: "/blog/budget-spreadsheet",
    element: <BlogBudgetSpreadsheet />,
  },
  {
    path: "/blog/sneakers-vs-boots",
    element: <BlogSneakersVsBoots />,
  },
  {
    path: "/blog/compare-online",
    element: <BlogCompareOnline />,
  },
  {
    path: "/blog/top-100-list",
    element: <BlogTop100 />,
  },
  {
    path: "/blog/fashion-database",
    element: <BlogFashionDatabase />,
  },
  {
    path: "/blog/vs-traditional",
    element: <BlogVsTraditional />,
  },
  {
    path: "/blog/value-sneakers-2026",
    element: <BlogValueSneakers />,
  },
  {
    path: "/blog/research-system",
    element: <BlogResearchSystem />,
  },
  {
    path: "/blog/buy-smarter",
    element: <BlogBuySmarter />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;